export default __webpack_public_path__ + "static/icon-4-1-362b95bef6649cad3d2ab07821391acf.png";